export default __webpack_public_path__ + "static/media/1.ae030cb2.jpg";